
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_34850_127533)","fill-opacity":".7"}},[_c('path',{attrs:{"d":"M17.083 14.87h-1.744l1.56 1.838-14.796.01 1.562-1.84-1.746.002-1.76 2.074a.665.665 0 00.506 1.095l17.67-.012a.665.665 0 00.507-1.096l-1.76-2.072zM7.855.95v3.933H4.68L9.5 9.723l4.819-4.84h-3.174V.95h-3.29zm5.873 6.14l-1.32 1.328h.95l3.54 4.172-14.795.01 3.55-4.182h.94L5.272 7.092a.665.665 0 00-.433.23L.158 12.835a.665.665 0 00.507 1.096l17.67-.012a.665.665 0 00.507-1.096l-4.67-5.5a.665.665 0 00-.444-.232z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_34850_127533"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h19v19H0z"}})])])])
          )
        }
      }
    